module.exports = __webpack_public_path__ + "img/Tail_feathers_Normal.c6c49e2.png";